// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-title{display:flex;align-items:center;margin-bottom:5px;-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.dropdown.active{visibility:visible}.dropdown.inactive{visibility:hidden;display:none}", ""]);
// Exports
module.exports = exports;
